import BasePanel from './BasePanel';
import { IIframelessWidgetInterface } from './IframelessElements/IframelessWidget';

class IframelessCommentsPanel extends BasePanel {
  constructor(private readonly widgetObject: IIframelessWidgetInterface) {
    super();
  }

  protected onPanelClose() {
    super.onPanelClose();
    this.widgetObject.hostDiv.appendChild(this.widgetObject.attachmentDiv);
  }

  public showPanel() {
    super.showPanel();
    this.panelContentDiv.appendChild(this.widgetObject.attachmentDiv);
    if (!this.widgetObject.widgetLoaded) {
      this.widgetObject.loadWidget();
    }
  }

  /**
   * Moves the ad unit from the in-page CW to the comments panel and back
   * @param direction The spot where the ad should be moved
   */
  protected moveAdUnitTo(direction: 'comments-panel' | 'original-spot') {
    const widgetParent = this.widgetObject.hostDiv;
    if (widgetParent) {
      const adContainer =
        direction === 'comments-panel'
          ? widgetParent.querySelector('.vuukle-ads')
          : this.panelContentDiv.querySelector('.vuukle-ads');
      if (adContainer) {
        direction === 'comments-panel' ? this.panelContentDiv.prepend(adContainer) : widgetParent.prepend(adContainer);
        const adElement = adContainer.querySelector('div[id*="div-gpt-ad"]');
        if (adElement) {
          const adId = adElement.id;
          // Refresh the ad unit. The reason we need to do this is because the ad unit iframe loses its state when moved and turns into a blank
          // and we don't want the ad to stay blank for too long
          if (window.vuuklehb && window.vuuklehb.vRefresh) {
            window.vuuklehb.vRefresh(adId, true);
          }
        }
      }
    }
  }
}

export default IframelessCommentsPanel;
